export default __webpack_public_path__ + "static/media/013-valenki.8d9ff24e.svg";